'use client'

import { useEffect } from 'react'

export default function CarDropScrollSync() {
  useEffect(() => {
    if (typeof window === 'undefined' || window.innerWidth < 768) return

    const leftPanel = document.querySelector('[data-scroll-sync="left"]') as HTMLElement
    const rightPanel = document.querySelector('[data-scroll-container="right-panel"]') as HTMLElement

    if (!leftPanel || !rightPanel) return

    const handleWheel = (e: WheelEvent) => {
      e.preventDefault()
      
      rightPanel.scrollBy({
        top: e.deltaY,
        behavior: 'auto'
      })
    }

    leftPanel.addEventListener('wheel', handleWheel, { passive: false })

    return () => {
      leftPanel.removeEventListener('wheel', handleWheel)
    }
  }, [])

  return null
}

